export default class Tabs {
    constructor(element) {
        this.element = element;
        this.navItems = this.element.querySelectorAll('.tabs__item');
        this.panels = this.element.querySelectorAll('.tabs__panel');
        this.init();
    }

    init() {
        this.navItems.forEach(item => {
            item.addEventListener('click', () => this.onTabClick(item));
        });

        const activeItem = this.element.querySelector('.tabs__item--active');
        if (activeItem) {
            this.showPanel(activeItem.dataset.tab);
        } else if (this.navItems.length > 0) {
            this.navItems[0].classList.add('tabs__item--active');
            this.showPanel(this.navItems[0].dataset.tab);
        }
    }

    onTabClick(item) {
        const target = item.dataset.tab;
        this.navItems.forEach(i => i.classList.remove('tabs__item--active'));
        this.panels.forEach(p => p.classList.remove('active'));
        item.classList.add('tabs__item--active');
        this.showPanel(target);
    }

    showPanel(tabName) {
        const panel = this.element.querySelector(`.tabs__panel[data-tab="${tabName}"]`);
        if (panel) {
            panel.classList.add('active');
            this.triggerResize(panel);
        }
    }

    triggerResize(panel) {
        const carousels = panel.querySelectorAll('[data-component="Carousel"]');
        carousels.forEach(c => {
            if (c.swiper) {
                c.swiper.update();
            }
            const slides = c.querySelectorAll('.swiper-slide');
            if (slides.length) {
                slides.forEach(slide => slide.style.height = 'auto');
                const maxHeight = Math.max(...Array.from(slides).map(slide => slide.offsetHeight));
                slides.forEach(slide => slide.style.height = `${maxHeight}px`);
            }
        });
    }
}
